export default function doesPartnerAllowCarvanaFinancing(partnerId) {
  return partnerId === 1 || partnerId === 40 || partnerId === 54;
}
